import { Controller as BaseController } from 'stimulus'
import Rails from '@rails/ujs'

export class Controller extends BaseController {
  static targets = ['queryField']
  static values = { singleSelection: String }

  disableField() {
    if (this.singleSelectionValue === 'true') {
      this.queryFieldTarget.disabled = true
    }
  }

  enableField() {
    if (this.singleSelectionValue === 'true') {
      this.queryFieldTarget.disabled = false
    }
  }

  showMore(event) {
    event.preventDefault()
    const controller = this.application.getControllerForElementAndIdentifier(this.element, 'collection-select')
    const params = controller.currentQueryKeyValuePairs()
    params.continuation_token = event.target.dataset.continuationToken
    Rails.ajax({
      type: 'get',
      url: '/collection_select/search_v2',
      data: $.param(params),
      success: (data) => {
        event.target.outerHTML = data.body.innerHTML
      }
    })
  }
}
